import { type ReactNode } from "react";

import { Label } from "@/components/ui/label";
import { ApiError } from "@/lib/api";

/** A labelled form field used across the catalog/contract editors. */
export function Field({
  label,
  className,
  children,
}: {
  label: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={`flex flex-col gap-1.5 ${className ?? ""}`}>
      <Label className="text-xs text-muted-foreground">{label}</Label>
      {children}
    </div>
  );
}

/** Surface Cinch's error body: 403 (not superuser), 409 (in use), or field-level
 *  validation ({field: [msgs]}). FastAPI wraps it as {detail: ...}; ApiError keeps
 *  the parsed body in `payload` (and stringifies it into `.message`). */
export function writeError(err: unknown): string {
  if (err instanceof ApiError) {
    const detail = (err.payload as { detail?: unknown } | undefined)?.detail;
    if (detail && typeof detail === "object") {
      const parts = Object.entries(detail as Record<string, unknown>).map(
        ([k, v]) => `${k}: ${Array.isArray(v) ? v.join(", ") : String(v)}`,
      );
      if (parts.length) return parts.join(" · ");
    }
    if (typeof detail === "string") return detail;
    return err.message;
  }
  return err instanceof Error ? err.message : "Save failed.";
}
